import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "margin-b-half" }
const _hoisted_2 = { class: "margin-b-half" }
const _hoisted_3 = ["disabled"]

import { computed, nextTick, onMounted, ref } from "vue";

import { SECTION } from "@/constants/assets.constant";
import { showToast } from "@/services/notification-manager";
import { useContentStore } from "@/stores/content.store";
import { useUIContentStore } from "@/stores/ui-content.store";

import { ContentTemplate } from "@/models/content-templates.model";

import { useFeatureFlags } from "@/composables/feature-flags";
import { useProductFeaturesManager } from "@/composables/product-features-manager";
import { useProductsManager } from "@/composables/products-manager";

import csHelper from "@/utils/product/content-structure-helpers";

import RightSidebar from "@/components/right-sidebars/ui/RightSidebar.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";

const NEW_CONTENT_NAME = "Placeholder";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateSection',
  setup(__props) {

const uiContentStore = useUIContentStore();
const contentStore = useContentStore();
const { product, structure } = useProductsManager();
const { isWorkflowManagementFeatureEnabled } = useProductFeaturesManager();
const { ffShouldTaskNotificationsBeSent } = useFeatureFlags();

const newSectionName = ref<string>(NEW_CONTENT_NAME);
const instruction = ref<string>("");
const isSubmitting = ref<boolean>(false);

const path = computed<string[]>(() => {
  if (
    structure.value &&
    structure.value.rootSection &&
    uiContentStore.newSectionDetails
  ) {
    const base =
      csHelper.getPathToSection(
        structure.value.rootSection,
        uiContentStore.newSectionDetails.parentId
      ) || [];
    const parent = csHelper.findDescendentSection(
      structure.value.rootSection,
      uiContentStore.newSectionDetails.parentId
    );
    return parent && parent.isRoot
      ? base
      : base.concat(parent ? parent.name : "");
  }
  return [];
});
const type = computed<ContentTemplate>(() => {
  return (
    product.value?.component_definitions.find((e: ContentTemplate): boolean => {
      return (
        !!uiContentStore.newSectionDetails &&
        e.id === uiContentStore.newSectionDetails.componentId
      );
    }) || ({} as ContentTemplate)
  );
});

const addContentSection = (): void => {
  if (uiContentStore.newSectionDetails) {
    isSubmitting.value = true;
    contentStore
      .upsertSections({
        productIds: [uiContentStore.newSectionDetails.productId],
        sections: [
          {
            type: uiContentStore.newSectionDetails.componentId,
            name: newSectionName.value,
            parent_section_id: uiContentStore.newSectionDetails.parentId,
            instruction: instruction.value ? instruction.value : undefined,
            users_to_notify:
              ffShouldTaskNotificationsBeSent.value &&
              isWorkflowManagementFeatureEnabled.value &&
              type.value.workflow_states.length > 0
                ? type.value.workflow_states[0].users
                : []
          }
        ]
      })
      .catch((error): void => {
        showToast({
          message: `${SECTION.ERRORS.notAdded}: ${error.message}`,
          type: "is-danger"
        });
      })
      .then((): void => {
        isSubmitting.value = false;
        newSectionName.value = NEW_CONTENT_NAME;
        instruction.value = "";
        uiContentStore.closeNewSectionSidebar();
      });
  }
};

const sectionNameInput = ref<HTMLInputElement | null>(null);
onMounted(async () => {
  await nextTick(() => {
    if (sectionNameInput.value) {
      sectionNameInput.value.focus();
    }
  });
});
uiContentStore.$subscribe((mutation, state) => {
  const newVal = state.newSectionDetails;
  nextTick(() => {
    if (newVal && sectionNameInput.value) {
      sectionNameInput.value.focus();
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(RightSidebar, {
    onCloseSidebar: _unref(uiContentStore).closeNewSectionSidebar,
    "close-btn-data-testing": 'close-curriculum-sidebar',
    "is-updating": false,
    "css-classes": ['curriculum-sidebar'],
    "is-close-btn-visible": true,
    "data-testing": 'curriculum-sidebar'
  }, {
    title: _withCtx(() => [
      _withDirectives(_createElementVNode("input", {
        id: "add-cs-name",
        class: "ghost-input",
        ref_key: "sectionNameInput",
        ref: sectionNameInput,
        "aria-label": "Enter name",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newSectionName).value = $event)),
        "data-testing": "add-content-section",
        placeholder: "Enter name ..."
      }, null, 512), [
        [
          _vModelText,
          newSectionName.value,
          void 0,
          { trim: true }
        ]
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(RightSidebarTitle, { title: 'Location:' }),
        _createElementVNode("span", null, _toDisplayString(_unref(product).name), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(path.value, (section) => {
          return (_openBlock(), _createElementBlock("span", { key: section }, " / " + _toDisplayString(section), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(RightSidebarTitle, { title: 'Instructions:' }),
        _withDirectives(_createElementVNode("textarea", {
          "data-testing": "add-instruction",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((instruction).value = $event))
        }, null, 512), [
          [_vModelText, instruction.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "full-width btn-1 create-cs",
          type: "button",
          disabled: !newSectionName.value || isSubmitting.value,
          "data-testing": "add-content-section-btn",
          onClick: addContentSection
        }, _toDisplayString("Add " + type.value.name), 9, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["onCloseSidebar"]))
}
}

})